<template>
    <div>
        <UiCardListHeader
            :title="lang('inquiries::inquiries.widgets.latest_inquiries.title')"
            :action-href="canManageInquiries ? route('inquiries.admin.index') : undefined"
            :action-label="canManageInquiries ? lang('inquiries::inquiries.actions.manage') : undefined"
        />

        <UiCardEmpty v-if="inquiries.length === 0">
            {{ lang('inquiries::inquiries.widgets.latest_inquiries.no_inquiries') }}
        </UiCardEmpty>
        <UiCardList
            v-else
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <inquiry-preview v-for="inquiry in inquiries" :key="inquiry.id" :inquiry="inquiry"></inquiry-preview>
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import InquiryPreview from '@src/Inquiries/Pages/Inquiry/InquiryPreview.vue';

const { props } = usePage();

const components: Ref<any[]> = ref(props.components);

const component = [...components.value].find((component) => component.component === 'InquiriesBlock');

const inquiries = ref(component ? component.inquiries : []);
const canManageInquiries = ref(component ? component.canManageInquiries ?? false : false);

const load = () => {
    axios.get(route('inquiries.admin.api.latest')).then(({ data }) => {
        inquiries.value = data.inquiries;
        canManageInquiries.value = data.canManageInquiries ?? false;
    });
};

window.Echo.channel('admin').listen('.inquiry.created', () => {
    load();
});

load();
</script>
